module.exports = __webpack_public_path__ + "static/media/store.b1a0e9fd.svg";